import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import { HeaderFactory } from '../../common/HeaderFactory'
import { TemplateSyncModel } from '../models/TemplateSyncModel';

declare const OUTCOMES_API: string;

@Injectable()
export class TemplateService {

    constructor(
        private http: Http,
        private headerFactory: HeaderFactory
    ) {
        //
    }

    syncWithDefault(): Observable<TemplateSyncModel> {
        return this.http.get(OUTCOMES_API + '/templates/sync-with-defaults', {
            headers: this.headerFactory.make()
        }).map(res => res.json());
    }

}


/** WEBPACK FOOTER **
 ** ./app/templatemgt/services/TemplateService.ts
 **/